import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Hero: React.FC = () => {
    return (
        <section className="relative w-full pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-gradient-to-br from-blue-900 to-blue-800">
            {/* Background Shapes/Waves - CSS approximation of the curved bottom */}
            <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none z-10 translate-y-[1px]">
                <svg className="relative block w-[calc(100%+1.3px)] h-[150px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="fill-white"></path>
                </svg>
            </div>

            {/* Content Container */}
            <div className="container mx-auto px-4 relative z-20 -mt-8 lg:-mt-16">
                <div className="flex flex-col lg:flex-row items-center">

                    {/* Left Text Content */}
                    <div className="lg:w-1/2 text-white mb-12 lg:mb-0">
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                        >
                            <h4 className="text-blue-300 font-semibold tracking-wide uppercase mb-4 pl-4 border-l-4 border-blue-400">
                                La Meilleure Solution CV
                            </h4>
                            <h1 className="text-5xl lg:text-7xl font-bold leading-tight mb-6">
                                Créez votre CV Pro <br />
                                En Quelques Clics
                            </h1>
                            <p className="text-blue-100 text-lg mb-8 max-w-lg leading-relaxed">
                                Démarquez-vous auprès des recruteurs grâce à nos modèles de CV modernes, professionnels et optimisés pour le marché de l'emploi.
                            </p>

                            <div className="flex flex-wrap gap-4">
                                <Link to="/register" className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-4 rounded-full font-semibold transition-all transform hover:-translate-y-1 shadow-lg flex items-center">
                                    Créer mon CV <ArrowRight className="ml-2 w-5 h-5" />
                                </Link>
                                <a href="#contact" className="bg-transparent border border-white text-white hover:bg-white hover:text-blue-900 px-8 py-4 rounded-full font-semibold transition-all">
                                    Nous contacter
                                </a>
                            </div>
                        </motion.div>
                    </div>

                    {/* Right Image Content */}
                    <div className="lg:w-1/2 relative">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                            className="relative z-10"
                        >
                            {/* Placeholder for the person image */}
                            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white/20">
                                <img
                                    src="/hgf.jpg"
                                    alt="Business Professional"
                                    className="w-full h-auto object-cover"
                                />
                                {/* Floating Badges (Optional decoration) */}
                                <div className="absolute top-10 right-10 bg-white/10 backdrop-blur-md p-4 rounded-xl border border-white/20 animate-pulse">
                                    <div className="w-8 h-8 rounded-full bg-blue-500"></div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
